export const MODAL_DATA_PARAM = 'md';
export const MODAL_PARAM = 'm';
export const PUSHED_MODAL_HISTORY_STATE = '__pushedModalEntry';
